import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Button from '../../../components/Button.js';
import SlideInOut from './SlideInOut';
import ProgressWithLabel from '../components/ProgressWithLabel';
import Alert from '@material-ui/lab/Alert';
import { withRequestFlowController } from './RequestFlowController';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'flex-start',
    minHeight: '65vh',
    padding: '2rem 1rem',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    padding: 0,
  },
  progress: {
    width: '10rem',
    '& .MuiLinearProgress-root': {
      height: '20px',
      borderRadius: '5px',
    },
  },
  container: {
    width: '100%',
    minHeight: '15rem',
    padding: '1rem 0',
    margin: '1rem 0',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: 0,
    },
  },
  buttons: {
    width: '100%',
    padding: '1.5rem 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

const RequestFlow = ({variant, providerName=null, listingTitle=null, services=null, requestId='', completedTo, dispatch, data, handleAnswer, submit, busy, previousStep, step, steps, progress, valid, delayMs}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.progress}>
          {step === 1 ? null : (<ProgressWithLabel variant="determinate" value={progress} />)}
        </div>
      </div>
      <div className={classes.container}>
        {steps.map(item => {
          if (step === item.id) {
            return (
              <SlideInOut key={item.id} in={true} mountOnEnter unmountOnExit timeout={{enter: delayMs, exit: delayMs}}>
                <div>
                  <item.content
                    name={variant === 'provider' ? providerName : listingTitle}
                    dispatch={dispatch}
                    handleAnswer={handleAnswer}
                    data={data}
                    completeButtonLabel="Back to site"
                    completeButtonTo={completedTo}
                    requestId={requestId}
                    services={services}
                  />
                  <div className={classes.buttons}>
                    {item.id === (steps.length - 1) && valid ? (
                      <Button
                        label="Finish"
                        onClick={submit}
                        pointer="right"
                        variant="contained"
                        disabled={busy}
                        busy={busy}
                        style={{marginBottom: '1.5rem', minWidth: '10rem'}}
                      />
                    ) : null }
                    {item.id === (steps.length - 1) && !valid ? (
                      <Alert severity="error">Please go back and answer all the questions to complete this request</Alert>
                    ) : null}
                    {(item.id > 2 && item.id < steps.length) ? (
                      <Button
                        onClick={previousStep}
                        label="Back"
                        pointer="left"
                        variant="text"
                        cssStyle="back"
                        disableRipple
                        style={{minWidth: '10rem'}}
                      />
                    ) : null}
                  </div>
                </div>
              </SlideInOut>
            );}
          return null;
        })}
      </div>
    </div>
  );
};

RequestFlow.propTypes = {
  variant: PropTypes.string.isRequired,
  providerName: PropTypes.string,
  listingTitle: PropTypes.string,
  services: PropTypes.array,
  requestId: PropTypes.string,
  completedTo: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  handleAnswer: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  busy: PropTypes.bool.isRequired,
  previousStep: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  steps: PropTypes.array.isRequired,
  progress: PropTypes.number.isRequired,
  valid: PropTypes.bool.isRequired,
  delayMs: PropTypes.number.isRequired,
};

export default withRequestFlowController(RequestFlow);
